import { render, staticRenderFns } from "./location-dialog-new.vue?vue&type=template&id=35c81488&scoped=true&"
import script from "./location-dialog-new.vue?vue&type=script&lang=js&"
export * from "./location-dialog-new.vue?vue&type=script&lang=js&"
import style0 from "./location-dialog-new.vue?vue&type=style&index=0&id=35c81488&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c81488",
  null
  
)

export default component.exports